<template>
	<div>
		<div class="row">
            <div class="col-md-12">
                <h4>LPG OVERVIEW</h4>
            </div>
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-4">
						<ListCompare title="SALES TOTAL" unit="M" :data="ytd.sales.rekap" itemcol="Info" valuecol="Value" url=""/>
					</div>
					<div class="col-md-4">
						<ListCompare title="SALES PSO" unit="M" :data="ytd.sales.pso" itemcol="Info" valuecol="Value" url=""/>
					</div>
					<div class="col-md-4">
						<ListCompare title="SALES NON PSO" unit="M" :data="ytd.sales.nonpso" itemcol="Info" valuecol="Value" url=""/>
					</div>
				</div>

				<div class="row">
					<div class="col-md-4">
						<BarCard title="SALES YTD (M)" :data="ytd.sales.ytdchart" :width="500" :height="280" url=""/>
					</div>
					<div class="col-md-4">
						<BarCard title="SALES MTD (M)" :data="ytd.sales.mtdchart" :width="500" :height="280" url=""/>
					</div>
					<div class="col-md-4">
                        <BarCard title="SALES MONTHLY (M)" :data="monthly.sales" :width="500" :height="280" url=""/>
					</div>
				</div>
			</div>

			<div class="col-md-3 pr-0" v-if="false">
				<div class="row">
					<div class="col-md-12">
					<ListItem title="NO OF AGENTS" :data="keagenan.province" itemcol="ProvinceName" valuecol="StoreCnt" url="/lpg/keagenan"/>
					</div>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import LPG from '@/components/page/LPG.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Footer from '@/views/Footer.vue'

export default{
	extends: LPG,
	components:{
		ListItem,
		ListCompare,
		BarCard,
		Footer
	},
    props: {
        intervalDuration: {
            type: Number,
            required: false,
            default: 15,
        },
        autoRequestActive: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            autoRequestInterval: null // Save interval ID
        }
    },
    mounted() {
		//this.loadYTD();
		//this.loadSales();
        //this.loadKeagenan(); //Unused

        if(this.autoRequestActive) {
            this.startAutoRequest();
        }
    },
    beforeDestroy() {
        // Stop interval when component destroyed
        if (this.autoRequestInterval) {
            clearInterval(this.autoRequestInterval);
        }
    },
    watch:{
        // Watcher untuk mendeteksi perubahan status auto request
        autoRequestActive(newValue) {
            if (newValue) {
                this.startAutoRequest();
            } else {
                this.stopAutoRequest();
            }
        },
        // Watcher untuk mendeteksi perubahan interval durasi
        intervalDuration(newValue) {
            if (this.autoRequestActive) {
                this.updateInterval();
            }
        },
	},
    methods:{
        startAutoRequest() {
            if (this.autoRequestInterval) {
                clearInterval(this.autoRequestInterval); // Hentikan interval lama
            }

            this.loadYTD(); // Ambil data pertama kali
            this.loadSales();
            this.autoRequestInterval = setInterval(() => {
                this.loadYTD(); // Ambil data setiap interval
                this.loadSales();
            }, this.intervalDuration * 1000); // Konversi detik ke milidetik
        },

        stopAutoRequest() {
            if (this.autoRequestInterval) {
                clearInterval(this.autoRequestInterval);
                this.autoRequestInterval = null;
            }
        },

        updateInterval() {
            if (this.autoRequestActive) {
                this.stopAutoRequest();
                this.startAutoRequest();
            }
        },
	},
}

</script>
